import { SvelteComponent, init, safe_not_equal, assign, is_function, element, space, create_component, text, attr, set_style, insert, mount_component, append, get_spread_update, get_spread_object, set_data, transition_in, transition_out, detach, destroy_component, exclude_internal_props } from '../../external_node_modules/svelte/internal/index.mjs.js';
import { t } from '../../i18n.js';
import Showcase from '../shared/components/Showcase/Showcase.svelte.js';
import FastGoldProductTile from './components/FastGoldProductTile/FastGoldProductTile.svelte.js';
import AdditionalProductTile from './components/AdditionalProductTile/AdditionalProductTile.svelte.js';
import '../../core/entity/product.entity.js';
import { RESOURCES } from './constants.js';
import './App.css.js';

/* src/ui/FastGold/App.svelte generated by Svelte v3.44.2 */

function create_additional_products_slot(ctx) {
	let additionalproducttile;
	let current;

	additionalproducttile = new AdditionalProductTile({
			props: {
				slot: "additional-products",
				onOpenMoreBundles: /*onOpenMoreBundles*/ ctx[3]
			}
		});

	return {
		c() {
			create_component(additionalproducttile.$$.fragment);
		},
		m(target, anchor) {
			mount_component(additionalproducttile, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const additionalproducttile_changes = {};
			if (dirty & /*onOpenMoreBundles*/ 8) additionalproducttile_changes.onOpenMoreBundles = /*onOpenMoreBundles*/ ctx[3];
			additionalproducttile.$set(additionalproducttile_changes);
		},
		i(local) {
			if (current) return;
			transition_in(additionalproducttile.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(additionalproducttile.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(additionalproducttile, detaching);
		}
	};
}

function create_fragment(ctx) {
	let h1;
	let t1;
	let div0;
	let t2;
	let span0;
	let t4;
	let showcase;
	let div;
	let t5;
	let span1;
	let t6;
	let t7;
	let div1;
	let current;

	const showcase_spread_levels = [
		/*$$props*/ ctx[5],
		{ products: /*productsToDisplay*/ ctx[4] },
		{ hideUnPurchasable: false },
		{ productComponent: FastGoldProductTile }
	];

	let showcase_props = {
		$$slots: {
			"additional-products": [create_additional_products_slot]
		},
		$$scope: { ctx }
	};

	for (let i = 0; i < showcase_spread_levels.length; i += 1) {
		showcase_props = assign(showcase_props, showcase_spread_levels[i]);
	}

	showcase = new Showcase({ props: showcase_props });

	showcase.$on("buy", function () {
		if (is_function(/*onBuy*/ ctx[1])) /*onBuy*/ ctx[1].apply(this, arguments);
	});

	showcase.$on("showDetails", function () {
		if (is_function(/*onShowDetails*/ ctx[2])) /*onShowDetails*/ ctx[2].apply(this, arguments);
	});

	return {
		c() {
			h1 = element("h1");
			h1.textContent = `${t('Приобретение дублонов')}`;
			t1 = space();
			div0 = element("div");
			t2 = space();
			span0 = element("span");
			span0.textContent = `${t('Выберите желаемое количество дублонов:')}`;
			t4 = space();
			div = element("div");
			create_component(showcase.$$.fragment);
			t5 = space();
			span1 = element("span");
			t6 = text(/*helpText*/ ctx[0]);
			t7 = space();
			div1 = element("div");
			attr(h1, "class", "fastgold-title wcl-1579py1");
			attr(div0, "class", "fastgold-divider wcl-1579py1");
			attr(span0, "class", "fastgold-description wcl-1579py1");
			set_style(div, "display", "contents");
			set_style(div, "--products-justify", "center");
			attr(span1, "class", "fastgold-help-text wcl-1579py1");
			attr(div1, "class", "fastgold-divider wcl-1579py1");
		},
		m(target, anchor) {
			insert(target, h1, anchor);
			insert(target, t1, anchor);
			insert(target, div0, anchor);
			insert(target, t2, anchor);
			insert(target, span0, anchor);
			insert(target, t4, anchor);
			insert(target, div, anchor);
			mount_component(showcase, div, null);
			insert(target, t5, anchor);
			insert(target, span1, anchor);
			append(span1, t6);
			insert(target, t7, anchor);
			insert(target, div1, anchor);
			current = true;
		},
		p(new_ctx, [dirty]) {
			ctx = new_ctx;

			const showcase_changes = (dirty & /*$$props, productsToDisplay, FastGoldProductTile*/ 48)
			? get_spread_update(showcase_spread_levels, [
					dirty & /*$$props*/ 32 && get_spread_object(/*$$props*/ ctx[5]),
					dirty & /*productsToDisplay*/ 16 && { products: /*productsToDisplay*/ ctx[4] },
					showcase_spread_levels[2],
					dirty & /*FastGoldProductTile*/ 0 && { productComponent: FastGoldProductTile }
				])
			: {};

			if (dirty & /*$$scope, onOpenMoreBundles*/ 520) {
				showcase_changes.$$scope = { dirty, ctx };
			}

			showcase.$set(showcase_changes);
			if (!current || dirty & /*helpText*/ 1) set_data(t6, /*helpText*/ ctx[0]);
		},
		i(local) {
			if (current) return;
			transition_in(showcase.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(showcase.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(h1);
			if (detaching) detach(t1);
			if (detaching) detach(div0);
			if (detaching) detach(t2);
			if (detaching) detach(span0);
			if (detaching) detach(t4);
			if (detaching) detach(div);
			destroy_component(showcase, detaching);
			if (detaching) detach(t5);
			if (detaching) detach(span1);
			if (detaching) detach(t7);
			if (detaching) detach(div1);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { onBuy } = $$props;
	let { onShowDetails } = $$props;
	let { onOpenMoreBundles } = $$props;
	let { products } = $$props;
	let { hideUnPurchasable = true } = $$props;
	let { helpText = null } = $$props;
	let { displayLimit = 3 } = $$props;

	if (helpText === null) {
		helpText = t('За дублоны вы можете приобрести уникальных командиров, премиум корабли и другое имущество в Адмиралтействе.');
	}

	let productsToDisplay = products;

	if (productsToDisplay) {
		productsToDisplay = productsToDisplay.filter(product => {
			var _a;

			return ((_a = product.entitlements) === null || _a === void 0
			? void 0
			: _a.find(item => item.type === RESOURCES.GOLD)) !== undefined;
		});

		productsToDisplay = hideUnPurchasable
		? productsToDisplay.filter(product => product.isPurchasable)
		: productsToDisplay;

		productsToDisplay = displayLimit !== 0
		? productsToDisplay.slice(0, displayLimit)
		: productsToDisplay;
	}

	$$self.$$set = $$new_props => {
		$$invalidate(5, $$props = assign(assign({}, $$props), exclude_internal_props($$new_props)));
		if ('onBuy' in $$new_props) $$invalidate(1, onBuy = $$new_props.onBuy);
		if ('onShowDetails' in $$new_props) $$invalidate(2, onShowDetails = $$new_props.onShowDetails);
		if ('onOpenMoreBundles' in $$new_props) $$invalidate(3, onOpenMoreBundles = $$new_props.onOpenMoreBundles);
		if ('products' in $$new_props) $$invalidate(6, products = $$new_props.products);
		if ('hideUnPurchasable' in $$new_props) $$invalidate(7, hideUnPurchasable = $$new_props.hideUnPurchasable);
		if ('helpText' in $$new_props) $$invalidate(0, helpText = $$new_props.helpText);
		if ('displayLimit' in $$new_props) $$invalidate(8, displayLimit = $$new_props.displayLimit);
	};

	$$props = exclude_internal_props($$props);

	return [
		helpText,
		onBuy,
		onShowDetails,
		onOpenMoreBundles,
		productsToDisplay,
		$$props,
		products,
		hideUnPurchasable,
		displayLimit
	];
}

class App extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			onBuy: 1,
			onShowDetails: 2,
			onOpenMoreBundles: 3,
			products: 6,
			hideUnPurchasable: 7,
			helpText: 0,
			displayLimit: 8
		});
	}
}

export { App as default };
//# sourceMappingURL=App.svelte.js.map
